import { Endereco } from "../pessoas/Endereco";
import { Empresa } from "./Empresa";

export class Filial {
    id: number;
    empresaId: number;
    matriz: boolean;
    nome: string;
    fantasia: string;
    cnpj: string;
    ie?: string | null;
    im?: string | null;
    cnae?: string | null;
    telefone?: string | null;
    enderecoId?: number | null;
    chavePos? : string | null;
    endereco?: Endereco | null;
    empresa?: Empresa | null;
  
    constructor(
      id: number,
      empresaId: number,
      matriz: boolean = false,
      nome: string = "",
      fantasia: string = "",
      cnpj: string = "",
      ie?: string | null,
      im?: string | null,
      cnae?: string | null,
      telefone?: string | null,
      enderecoId?: number | null,
      chavePos? : string | null,
      endereco?: Endereco | null,
      empresa?: Empresa | null
    ) {
      this.id = id;
      this.empresaId = empresaId;
      this.matriz = matriz;
      this.nome = nome;
      this.fantasia = fantasia;
      this.cnpj = cnpj;
      this.ie = ie || null;
      this.im = im || null;
      this.cnae = cnae || null;
      this.telefone = telefone || null;
      this.enderecoId = enderecoId || null;
      this.chavePos = chavePos;
      this.endereco = endereco || null;
      this.empresa = empresa || null;
    }
  }
  